import { httpClient } from '@/infra/protocols/http';

export async function deleteEpisode(
  params: DeleteEpisodeService.Params,
): Promise<DeleteEpisodeService.Response> {
  const response = await httpClient.delete<{ mensagem: string }>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}`,
  );

  return {
    message: response.mensagem,
  };
}

export namespace DeleteEpisodeService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: number;
  }

  export type Response = {
    message: string;
  };
}
